import React, { useEffect, useRef, useState } from 'react';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal, Form, InputGroup, Row, Col } from 'react-bootstrap';
import { faArrowLeft, faPlus, faLink } from '@fortawesome/free-solid-svg-icons';
import { withoutRFSToken, withRFSToken, } from '../../../Services/axios.js';
import Trash from "../../../assets/images/delete.svg";
import Edit from "../../../assets/images/edit.png";
import Select from 'react-select';
import { MultiSelect } from 'react-multi-select-component'; 
import { toast } from 'react-toastify';
import { jqxCookieCall } from '../../../Components/common/CommonFunctions.js';

export const RegionSettings = () => {
    const SBack = localStorage.getItem('SettingsBack');
    const gridRef = useRef(null);
    const [addregionModal, setAddregionModal] = useState(false);
    const [countryData, setCountryData] = useState([]);
    const isMounted = useRef(false);
    const gridRefs = useRef({});
    const [allData, setAlldata] = useState(null);
    const [deleteId, setDeleteId] = useState();
    const [confModal, setConfModal] = useState(false);
    const [formData, setFormData] = useState({
        region_name: "",
        country: [],
        id: "",
    });

    const closeaddregionModal = () => {
        setAddregionModal(false);
    }

    const regionSave = async () => {
        const res = await withRFSToken.post('setting/add-update', formData);
        if (res.data.response_code === 200) {
            toast.success(res.data.response_msg);
            closeaddregionModal();
            loadGrid();
        } else {
            toast.error(res.data.response_msg);
        }
    };

    const handleAddRegionClick = () => {
        setAddregionModal(true);
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    useEffect(() => {
        if (isMounted.current) return;
        fetchCountry();
        loadGrid();
        isMounted.current = true;
    }, []);

    const fetchCountry = async () => {
        try {
            const res = await withRFSToken.get('uld-forms/get-country-name', {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setCountryData(innerData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        console.log(formData);
    }, [formData]);

    const handleDeleteConfirm = async () => {
        try {
            const res = await withRFSToken.post(`setting/delete-restore?id=${deleteId}`)
                .then(function (res) {
                    if (res.data.response_code === 200) {
                        toast.success(res.data.response_msg);
                        loadGrid();
                        setConfModal(false);
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const loadGrid = () => {
        // const token = 'Bearer ' + localStorage.RFS;
        jqxCookieCall()
        const source = {
            datatype: 'json',
            url: `${process.env.REACT_APP_RFS_URL}setting/list`,
            root: 'Rows',
            cache: false,
            datafields: [
                { name: 'id', type: 'string' },
                { name: 'country', type: 'string' },
                { name: 'region_name', type: 'string' }
            ],
            // beforeSend: (jqXHR) => {
            //     jqXHR.setRequestHeader('Authorization', token);
            // },
            filter: function (allfilters) {
                window.$(gridRefs.current).jqxGrid('clearselection');
                window.$(gridRefs.current).jqxGrid("updatebounddata", "filter");
            },
            beforeprocessing: function (data) {
                setAlldata(data.Rows);
            }
        };
        const dataAdapter = new window.$.jqx.dataAdapter(source);
        const columns = [
            {
                text: 'Action', datafield: '', width: '5%', filterable: false, filtertype: '',
                cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                    return `<div class="grid_actions"><img class="file_download row_edit" src="${Edit}"/><img class="row_delete" src="${Trash}"/></div>`;
                }
            },
            { text: 'Region Name', datafield: 'region_name', width: '8%', filtertype: 'input', },
            { text: 'Country', datafield: 'country', width: '85%', filtertype: 'input', },
        ];
        const gridOptions = {
            width: '100%',
            source: dataAdapter,
            columns: columns,
            autoheight: false,
            height: 800,
            sortable: true,
            altrows: false,
            enabletooltips: true,
            editable: false,
            pageable: true,
            pageSize: 50,
            pagerButtonsCount: 5,
            pagerMode: 'advanced',
            filterable: true,
            filterrowheight: 45,
            showfilterrow: true,
            rowsheight: 42,
            columnsheight: 45,
            virtualmode: true,
            rendergridrows: function (params) {
                return params.data;
            },
        };
        window.$(gridRefs.current).jqxGrid(gridOptions);
        window.$(gridRefs.current).off('click', '.row_edit').on('click', '.row_edit', function () {
            const rowDiv = window.$(this).closest('[role="row"]');
            const rowIndex = window.$(rowDiv).attr('row-id');
            const rowData = window.$(gridRefs.current).jqxGrid('getrowdata', rowIndex);
            setFormData(rowData);
            handleAddRegionClick();
        });
        window.$(gridRefs.current).off('click', '.row_delete').on('click', '.row_delete', function () {
            const rowDiv = window.$(this).closest('[role="row"]');
            const rowIndex = window.$(rowDiv).attr('row-id');
            const rowData = window.$(gridRefs.current).jqxGrid('getrowdata', rowIndex);
            setDeleteId(rowData.id);
            setConfModal(true);
        });
    }
    
    return (
        <>
            {/* <div className="">
                <Header logo_url={SBack ? SBack : '/BookingtruckSchedule'} sBackUrl={SBack ? SBack : '/BookingtruckSchedule'} />
                <div className="main-panel">
                    <div className="row">
                        <LeftSettings /> */}
                        <div className='col-9 col-xxl-9 stting_right'>
                            <div className='settingbg_right'>
                                <h4>Region Settings</h4>
                                <p>Manage and configure regional settings</p>
                                <div className='row'>
                                    <div className='col-12'>
                                        <div className='d-flex justify-content-between mb-3'>
                                            <Button variant="primary createplan mb-0" onClick={() => {
                                                handleAddRegionClick();
                                                setFormData({
                                                region_name: "",
                                                country: [],
                                                id: "",
                                                });
                                            }}>
                                                <FontAwesomeIcon icon={faPlus} /> Add Region
                                            </Button>
                                        </div>                                      
                                        <div ref={gridRefs} className='staion_grid' ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    {/* </div>
                </div>
            </div> */}
            <Modal show={addregionModal} onHide={closeaddregionModal} className="addfrom change_type" centered>
                <Modal.Header closeButton onClick={closeaddregionModal}></Modal.Header>
                <Modal.Body>
                    <h3>Create Region</h3>
                    <p>Enter region information below</p>
                    <Form.Group controlId="dropdown" className='mt-3'>
                        <Form.Label>Region Name  <span style={{ color: 'red' }}>*</span></Form.Label>
                        <Form.Control
                            type="text"
                            value={formData.region_name}
                            name='region_name'
                            onChange={handleChange}
                            placeholder="Region Name "
                        />
                    </Form.Group>
                    <Form.Group controlId="dropdown" className='mt-3'>
                        <Form.Label>Country <span style={{ color: 'red' }}>*</span></Form.Label>
                        <Select
                            options={countryData}
                            placeholder="Country Name"
                            className=''
                            onChange={(selected) => {
                                const selectedValues = selected ? selected.map(option => option.value) : [];
                                setFormData({ ...formData, country: selectedValues });
                            }}
                            name="country"
                            value={countryData.filter(opt => formData.country?.includes(opt.value))}
                            isMulti
                        />
                    </Form.Group>
                    {/* <Form.Group controlId="dropdown" className='mt-3'>
                        <Form.Label>Station <span style={{ color: 'red' }}>*</span></Form.Label>
                        <MultiSelect
                            options={countryData}
                            value={formData.station}
                            onChange={(selected) => {
                                const updatedData = { ...formData, station: selected };
                                setFormData(updatedData);
                            }}
                            labelledBy="Select "
                            className='multiselect'
                            name="station"
                        />
                    </Form.Group> */}

                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex w-50 mx-auto are_bottom">
                        <Button variant="secondary" onClick={closeaddregionModal}> Cancel</Button>
                        <Button variant="primary" onClick={() => regionSave()}> Save </Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={confModal} onHide={() => setConfModal(false)} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>Delete Region</h3>
                    <p>Are you sure you want to delete this Region? This action cannot be undone.</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={() => setConfModal(false)}>
                            No
                        </Button>
                        <Button variant="primary" onClick={handleDeleteConfirm}>
                            Yes
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default RegionSettings;